import { render, staticRenderFns } from "./NpButton.vue?vue&type=template&id=018a09ee&scoped=true&"
import script from "./NpButton.vue?vue&type=script&lang=ts&"
export * from "./NpButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018a09ee",
  null
  
)

export default component.exports